import TitleBorderLeft from "../../../components/Text/TitleBorderLeft";
import BorderLeftBox from "../../../components/boxes/BorderLeftBox";

const stakeholdersPageData= {
    header : {
        image : {
            name : "stakeholders.jpg",
            alt : "Listen to Stakeholders page wallpaper",
        },
    },
    mainTitle : "Listening to Our Stakeholders",
    paragraphOne : "SAB believes in the importance of healthy two-way communication and collaboration with all our priority stakeholders. By working together with these stakeholders, we ensure that we deliver sustainable shared value in the short, medium and long-term. We understand that every stakeholder differs in their objectives, expectations, and interests. As such, we tailor our engagements to meet the needs of each stakeholder group and use their inputs to enhance our ESG strategy.",
    infoGraphicOne : {
        nameOne : "stakeholder-1.svg",
        nameTwo : "stakeholder-2.svg",
        alt : "Description for stakeholder plan",
    },
    tabs : {
        headers : [
            "Customers",
            "Employees",
            "Regulators",
            "Local communities",
            "Shareholders and investors",
            "Business partners",
            "Suppliers and service providers",
        ],
        data : [
            <>
                <BorderLeftBox 
                    title={"Customers"}
                    subtitle={"A sustainable customer base is what makes SAB viable in the long-term, to keep supporting the Kingdom and Vision 2030. By listening to the market, we provide market-leading services that supports our customers’ goals and ambitions, paving the way for sustainable long-term relationships. We use employee communication campaigns and training to promote a SAB culture of putting the customer first."}
                />
                <h3 className="text-title-small-2">Customer priorities</h3>
                <ul className="normal-list pl-2">
                    <li>Customer experience</li>
                    <li>Digital transformation</li>
                    <li>Competitive financial and non-financial benefits to products</li>
                    <li>Protection against fraud</li>
                    <li>Interest rates </li>
                    <li>ESG-linked deposits and derivatives </li>
                    <li>Connecting customers to international opportunities</li>
                </ul>
                <div className="space-50"></div>
                <div className="area-gray">
                    <h4 className="aria-title">Relationship metrics</h4>
                </div>
                <div className="area-white">
                    <p className="area-red-text">
                        Customer Recommendation Index (CRI)
                    </p>
                </div>
                <table className="area-table area-border-bottom">
                    <tr>
                        <th>WPB:</th>
                        <td>CIB:</td>
                    </tr>
                    <tr>
                        <th>96.4</th>
                        <td>93.4</td>
                    </tr>
                    <tr>
                        <th>(Rank 1)</th>
                        <td>(Rank 1)</td>
                    </tr>
                </table>
                <div className="area-white area-border-top">
                    <p className="area-red-text">
                        Brand Health Index (BHI)
                    </p>
                </div>
                <table className="area-table">
                    <tr>
                        <th>WPB:</th>
                        <td>CIB:</td>
                    </tr>
                    <tr>
                        <th>78.6</th>
                        <td>70.8</td>
                    </tr>
                    <tr>
                        <th>(Rank 1)</th>
                        <td>(Rank 1)</td>
                    </tr>
                </table>
                <div className="area-gray">
                    <h4 className="aria-title">Engagement channels</h4>
                    <ul className="area-text">
                        <li>Voice of the Customer Programme</li>
                        <li>Online banking and mobile banking app</li>
                        <li>Customer feedback form</li>
                        <li>Customer service centres</li>
                        <li>Email/Newsletters</li>
                    </ul>
                </div>
                <div className="space-50"></div>
                <TitleBorderLeft>2022 highlights</TitleBorderLeft>
                <p className="text-paragraph">In 2022, we are proud to have won the “Best Bank for Customer Experience KSA” Award from Global Brands Magazine. This is a testament to our efforts to improve the customer experience. We were pleased to achieve the second best attrition rate of all the top banks in the Kingdom at 10% (of active customers), according to data from market sources. </p>
                <p className="text-paragraph">An additional highlight is our use of robotic process automation (RPA) to manage customer complaints more efficiently. Further, we implemented a customer experience innovation (CXI) programme by leveraging our digital capabilities and data to gain a holistic view of the customer experience at SAB. By improving our processes, we aim to exceed customer expectations at every touchpoint.</p>
                <p className="text-paragraph">Looking ahead, we will continue enhancing the customer experience by increasing our customer feedback checkpoints, refreshing our customer experience benchmarking studies, identifying and taking advantage of gaps in the market, and driving an internal culture aimed at positive customer experiences.</p>
            </>,
            <>
                <BorderLeftBox 
                    title="Employees"
                    subtitle="Our employees are at the heart of long-term value creation for our stakeholders. We view investing in our employees and focusing on embedding our company culture as critical enablers of success. Attracting, Retaining and Developing future-fit talent is a core part of our vision and this enables SAB to bring a world of financial opportunities to an ambitious kingdom. Nurturing Saudi talent, supporting women, and empowering the next generation are integral to who we are, and our employees give us a competitive advantage in the market by allowing us to serve customers better. We emphasise continual development for all our staff members in the areas of leadership, communication and customer experience. "
                />
                <h3 className="text-title-small-2">Employee priorities</h3>
                <ul className="normal-list pl-2">
                    <li>A positive work environment </li>
                    <li>Work-life balance </li>
                    <li>Fair remuneration and benefits </li>
                    <li>Training and development </li>
                    <li>Transparency between Management and employees</li>
                    <li>Opportunities for Saudi nationals </li>
                </ul>
                <div className="space-50"></div>
                <div className="area-gray">
                    <p className="area-title">Relationship metrics</p>
                </div>
                <div className="area-white area-border-bottom-none">
                    <p className="">Annual employee engagement score: 73% </p>
                </div>
                <div className="area-gray">
                    <p className="area-title">Engagement channels </p>
                    <ul className="area-list">
                        <li>Informal meetings and discussions with the Management team </li>
                        <li>Leadership Town Hall discussions on thematic topics</li>
                        <li>Accelerating into leadership junior manager development programme </li>
                        <li>Strategy corners </li>
                        <li>Team events</li>
                        <li>Recognition events e.g. service awards </li>
                        <li>International event days</li>
                        <li>ESG activities, including tree planting activities </li>
                        <li>Annual Employee Survey</li>
                        <li>SAB Graduate programme</li>
                        <li>LinkedIn and Coursera learning platforms</li>
                    </ul>
                </div>
                <div className="space-50"></div>
                <TitleBorderLeft>2022 highlights </TitleBorderLeft>
                <p className="text-paragraph">The annual SAB employee survey was conducted in September 2022, with 99% of employees participating. The survey results provided valuable insights into the extent to which our employees are aware of the Bank’s 2025 strategy. The survey also provided insights on employee engagement and commitment levels in supporting the Bank’s strategy. We are pleased to have achieved a 73% employee engagement score, a significant increase from 58% in 2021. SAB takes employee comments and feedback very seriously and aims to improve employee engagement as a means of ensuring the future success of the Bank and its staff.</p>
                <p className="text-paragraph">During 2022, we continued implementing our Bravo Recognition programme for applicable branches and sales staff. The initiative recognises and promotes a positive corporate culture by offering financial and non-financial rewards for employees who go the extra mile for customers, each other, and the Bank. </p>
            </>,
            <>
                <BorderLeftBox 
                    title="Regulators"
                    subtitle="Our regulatory authorities include the Ministry of Commerce (MC), the Saudi Central Bank (SAMA), the Capital Market Authority (CMA) and the Zakat, Tax and Customs Authority (ZATCA). We uphold the highest levels of good governance and conduct regular internal reviews to assess and ensure compliance with all the regulatory requirements issued by MC, SAMA and CMA. In addition, we seek to remain abreast of relevant changes in the regulatory environment as well as local and international best practice. Our relationship with the regulators goes beyond compliance – we view them as our partners in helping to achieve the Kingdom’s financial sector goals to support Vision 2030. "
                />
                <h3 className="text-title-small-2">Regulatory priorities </h3>
                <ul className="normal-list pl-2">
                    <li>Supporting the MSME sector and other priority industries for Vision 2030</li>
                    <li>SAB’s adherence to regulatory requirements </li>
                    <li>Economic diversification </li>
                    <li>KSA playing a greater economic role in the GCC</li>
                </ul>
                <div className="space-50"></div>
                <div className="area-gray">
                    <p className="area-title">Relationship metrics</p>
                </div>
                <div className="area-white area-border-bottom-none">
                    <p>SAB contributes to consultations and, where appropriate, proactively and transparently seek our regulatory stakeholders’ input on matters within their jurisdiction. Furthermore, SAB meets with regulatory members to build good relationships and to discuss concerns of similar organisations and the possible solutions thereto.</p>
                </div>
                <div className="area-gray">
                    <h4 className="area-title">Engagement channels</h4>
                    <ul className="area-list">
                        <li>Responses to requests for input</li>
                        <li>Interpersonal meetings and video conferencing</li>
                        <li>Monitoring official communication channels</li>
                    </ul>
                </div>
                <div className="space-50"></div>
                <TitleBorderLeft>2022 highlights</TitleBorderLeft>
                <p className="text-paragraph">SAB’s CEO, Tony Cripps, intends to support the banking ecosystem across Saudi Arabia and contribute to the development of effective ESG policies and regulations in line with Vision 2030. Our international experience through HSBC provides unique insights into global best practice, allowing the local market to learn and implement suitable practices for the Kingdom. The approach also allows SAB and other financial institutions to gain from the experiences of those in other regulatory jurisdictions.</p>
            </>,
            <>
                <BorderLeftBox 
                    title="Local communities"
                    subtitle="Our local communities – Saudi citizens in particular – are important to us. Given our status as a major player in the Saudi financial sector, we are responsible for the wellbeing of the communities in which we operate, and for contributing to a healthy and prosperous society. Our long-standing partnerships with government agencies and charities allow us to participate in a range of social programmes designed to support our communities in the short and medium-term."
                />
                <h3 className="text-title-small-2">Community priorities </h3>
                <ul className="normal-list pl-2">
                    <li>Supporting the MSME sector</li>
                    <li>Empowering young people</li>
                    <li>Saudisation</li>
                    <li>Financial literacy</li>
                    <li>Charitable and social investment initiatives</li>
                    <li>Opening the Kingdom for investment and tourism</li>
                    <li>Infrastructure development</li>
                </ul>
                <div className="space-50"></div>
                <div className="area-gray">
                    <p className="area-title">Relationship metrics</p>
                </div>
                <div className="area-white area-border-bottom-none">
                    <p>We rely on reports and feedback from our partners who support the delivery of community programmes. We generally receive reports on a monthly basis, and at times we receive a report once the programme has been delivered.</p>
                </div>
                <div className="area-gray">
                    <h4 className="area-title">Engagement channels / Community partners</h4>
                    <ul className="area-list">
                        <li>Monsha’at MSME sector development</li>
                        <li>Taqadam incubator programme for MSMEs</li>
                        <li>Riyali financial literacy programme</li>
                        <li>SAB Digital Academy for young people</li>
                        <li>Saudi Food Bank initiative to support families in need</li>
                        <li>Supporting children with special needs and their parents </li>
                        <li>National Centre CSR to enhance financial literacy</li>
                        <li>Al-Nahda Society to support women</li>
                        <li>Sanad Children’s Cancer Support Association </li>
                    </ul>
                </div>
                <div className="space-50"></div>
                <TitleBorderLeft>2022 highlights</TitleBorderLeft>
                <p className="text-paragraph">SAB aims to provide long-term benefits to communities. This enables us to achieve a meaningful impact in a sustainable manner. In 2022, we refined our Corporate Social Responsibility Policy to focus on supporting MSMEs, education and the environment.</p>
            </>,
            <>
                <BorderLeftBox 
                    title="Shareholders and investors"
                    subtitle="Our investor community provides us with capital to execute our long-term strategy. They are part of a wide variety of stakeholders including existing shareholders, potential investors, local and global banking equity research analysts, economists and analysts in various sectors and specialties. SAB’s Investor Relations (IR) strategy is relationship-focused and aims to build long-term sustainable relationships with these groups, encouraging two-way dialogue through a variety of mediums. The IR programme aims to provide the investor community with valuable insights into the Bank’s strategy and performance. This two-way dialogue also provides the Bank with important market insights."
                />
                <div className="space-50"></div>
                <div className="area-gray">
                    <div className="area-flex">
                        <div className="area-col">
                            <h4 className="area-title">Shareholder and investor priorities</h4>
                            <ul className="area-list">
                                <li>Delivering long-term sustainable growth to their investment</li>
                                <li>Understanding SAB’s long-term strategy and financial performance</li>
                                <li>Understanding SAB’s ESG strategy and commitments, and how it complements the overall strategy</li>
                            </ul>
                        </div>
                        <div className="area-col">
                            <h4 className="area-title">Engagement channels / Community partners</h4>
                            <ul className="area-list">
                                <li>Quarterly earnings calls </li>
                                <li>Local, regional, and international investor conferences</li>
                                <li>Regular meetings with the analyst community </li>
                                <li>Regular meetings with investors locally at our offices, and also virtual meetings</li>
                                <li>Annual General Meeting</li>
                                <li>Documented updates, including regular presentations, earning releases, and transcripts that can be accessed from our website </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="space-50"></div>
                <TitleBorderLeft>2022 highlights</TitleBorderLeft>
                <ul className="normal-list pl-2">
                    <li>Attendance at all major Saudi-focused investor conferences, including all that were sponsored by the Saudi Exchange</li>
                    <li>Over 100 meetings held with individual investors and shareholders during 2022 across organised investor conferences and visits to our offices, engaging with more than 170 different investors and analysts</li>
                    <li>Delivering an 18% increase in our market capitalisation during 2022, which was ahead of the banking sector in the Kingdom</li>
                </ul>
            </>,
            <>
                <BorderLeftBox 
                    title="Business partners"
                    subtitle="Our business partners are key to the trust that we build with our customers. We engage high-quality and reputable business partners."
                />
                <h3 className="text-title-small-2">Business partner concerns</h3>
                <ul className="normal-list pl-2">
                    <li>SAB’s financial performance and brand health </li>
                    <li>Our alignment to Vision 2030</li>
                    <li>Transformed and streamlined processes </li>
                    <li>SAB’s reputation in the marketplace</li>
                    <li>Greater collaboration</li>
                </ul>
                <div className="space-50"></div>
                <div className="area-gray">
                    <p className="area-title">Relationship metrics</p>
                </div>
                <div className="area-white area-border-bottom-none">
                    <p>Ongoing agreements and meetings</p>
                </div>
                <div className="area-gray">
                    <h4 className="area-title">Engagement channels</h4>
                    <ul className="area-list">
                        <li>MoU’s / Contracts </li>
                        <li>One-on-one interpersonal meetings and engagements</li>
                    </ul>
                </div>
                <div className="space-50"></div>
                <TitleBorderLeft>2022 highlights</TitleBorderLeft>
                <p className="text-paragraph">In 2022, SAB signed a joint agreement with Marooj Foundation, the execution arm of the National Centre for Vegetation Cover (NCVC), to contribute to the Saudi Green Initiative (SGI) by planting 1 million trees across the Kingdom by 2030.</p>
            </>,
            <>
                <BorderLeftBox 
                    title="Suppliers and service providers"
                    subtitle="High-quality suppliers and service providers enable us to deliver the best products and services to the market. As with all our other stakeholders, we look to engage the best partners for mutual benefit."
                />
                <h3 className="text-title-small-2">Supplier and service provider priorities</h3>
                <ul className="normal-list pl-2">
                    <li>Timely invoice payments</li>
                    <li>Cash flow</li>
                    <li>Vendor selection processes</li>
                </ul>
                <div className="space-50"></div>
                <div className="area-gray">
                    <p className="area-title">Relationship metrics</p>
                </div>
                <div className="area-white">
                    <p>Quality of products/services </p>
                </div>
                <div className="area-white">
                    <p>Delivery</p>
                </div>
                <div className="area-white area-border-bottom-none ">
                    <p>Cost</p>
                </div>
                <div className="area-gray">
                    <h4 className="area-title">Engagement channels</h4>
                    <ul className="area-list">
                        <li>One-on-one interpersonal meetings and engagements</li>
                        <li>Annual vendor assessments</li>
                    </ul>
                </div>
                <div className="space-50"></div>
                <TitleBorderLeft>2022 highlights</TitleBorderLeft>
                <p className="text-paragraph">In 2022, SAB added a Code of Conduct agreement to the Bank’s vendor registration requirements to ensure compliance with our environment, society, governance, economy, health and safety, and ethics standards. We also conducted a sanction check, inherent risk assessment and residual risk assessment of our vendors to ensure that they maintain the same standard of risk governance as we do internally for our own operations. We now conduct a supplier evaluation annually, with contract renewals being re-assessed for risk before renewing.</p>
                <p className="text-paragraph">Earlier this year, SAB received the Chartered Institute of Purchasing and Supply (CIPS) “Excellence in Procurement Programme (PEP)” award for successfully completing the comprehensive standards for the development of its procurement and supply activities and achieving excellence in managing procedures at the standard level. This is one of the most prestigious international awards, and it is given to institutions and companies that achieve the highest levels of excellence in procurement activities and supply chains, based on an independent and comprehensive evaluation designed specifically for the procurement functions.</p>
                <div className="space-50"></div>
                <img 
                    src={require('../../../assets/images/sections/stakeholder-1.jpg')} 
                    alt="Supplier and service provider priorities wallpaper" 
                    className="area-image"
                />
            </>,
        ],
    }
};

export default stakeholdersPageData;